import moment from "moment-timezone";

const toOption = (timezone) => ({
  key: timezone,
  value: timezone,
  text: timezone,
});

// The API validates with Laravel's `timezone:all` (PHP's DateTimeZone::ALL),
// which is the zone.tab set plus UTC. moment.tz.names() also has backward-compat
// aliases (GB, US/Eastern, Etc/GMT+1...) that the API rejects. Etc/GMT+1 is
// also UTC-1, not BST, despite the name.
// Asia/Choibalsan: still in moment's tzdata 2024a, removed from PHP's in 2024b.
const SUPPORTED_TIMEZONES = (() => {
  const zones = new Set(["UTC"]);
  moment.tz.countries().forEach((country) => {
    moment.tz.zonesForCountry(country).forEach((zone) => zones.add(zone));
  });
  zones.delete("Asia/Choibalsan");
  return zones;
})();

const SUPPORTED_OPTIONS = [...SUPPORTED_TIMEZONES].sort().map(toOption);

// `saved` keeps an already-saved zone selectable if it's not in the list.
export function getTimezoneOptions(saved) {
  return saved && !SUPPORTED_TIMEZONES.has(saved)
    ? [toOption(saved), ...SUPPORTED_OPTIONS]
    : SUPPORTED_OPTIONS;
}
